import { connect } from 'react-redux'
import { RootState } from 'duck/store'

import { getAccountPageState } from 'scenes/Account/duck/selectors'
import { resetPasswordBegin } from 'scenes/Account/duck/actions'

import RestorePasswordForm from './ResetPasswordForm.presentational'

function mapStateToProps(state: RootState) {
  const { isLoading, resetAuthError } = getAccountPageState(state)
  return {
    loading: isLoading,
    authError: !!resetAuthError,
  }
}

export default connect(mapStateToProps, {
  onSubmit: resetPasswordBegin,
})(RestorePasswordForm)
